import(/* webpackMode: "eager", webpackExports: ["SozlesmeSayfasi"] */ "/app/src/features/yasal/components/sozlesme-sayfasi.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["YasalBelgeDialog"] */ "/app/src/features/yasal/components/yasal-belge-dialog.tsx");
